import './styles/globals.css'

import React from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import { IPublicClientApplication } from '@azure/msal-browser'

import { createRoutes } from './createRoutes'

type Props = {
  publicClientApplication: IPublicClientApplication
}

const App: React.FC<Props> = ({ publicClientApplication }) => {
  const router = createBrowserRouter([createRoutes(publicClientApplication)])

  return <RouterProvider router={router} />
}

export default App
